<template>
  <v-autocomplete
    v-model="selected"
    :items="filteredTechnicians"
    :label="label"
    no-data-text="Nenhum técnico encontrado"
    :loading="loading"
    :rules="rules"
    outlined
    dense
    item-text="name"
    item-value="id"
    return-object
    hide-details="auto"
    :multiple="multiple"
    :chips="multiple"
  >
    <template v-slot:item="{ item }">
      <div class="d-flex flex-column py-1">
        <b>{{ item.name || "Conta não criada" }}</b>
        <span class="text-caption">{{ item.phone }}</span>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import BaseSelector from "./BaseSelector.vue";
import TECHNICIANS from "@/services/admin/technicians";

export default {
  components: { BaseSelector },
  props: {
    value: {
      type: Object | null,
      required: true,
    },
    label: {
      type: String,
      default: "Selecione um técnico",
    },
    permission: {
      type: Number | Array | null,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    platforms: {
      type: Array | null,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filterTechnicians: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      technicians: [],
    };
  },
  methods: {
    async getTechnicians() {
      try {
        this.loading = true;
        var response = await TECHNICIANS.getAll();
        this.technicians = response.masterPermissions.map(
          ({ platformId, User }) => ({
            ...User,
            platformId,
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    filteredTechnicians() {
      var technicians = this.technicians;
      if (this.filterTechnicians)
        technicians = technicians.filter(this.filterTechnicians);

      if (!this.platforms) return technicians;
      return technicians.filter((t) => this.platforms.includes(t.platformId));
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    this.getTechnicians();
  },
};
</script>
